import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {CreditSetupResponse, CreditSetupStatus} from '@brightside-web/desktop/data-access/shared';
import {CreditSetupService} from '@brightside-web/desktop/data-access/credit';
import { BsCacheService } from "@brightside-web/desktop/data-access/core-services";
import {from, Observable, switchMap} from 'rxjs';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class InSetupGuard implements CanActivate {
  constructor(
    private router: Router,
    private creditSetupService: CreditSetupService,
    private bsCacheService: BsCacheService) {}
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.creditSetupService.getSetupStatus().pipe(
      switchMap((resp: CreditSetupResponse) => {
        return from(this.bsCacheService.getItem('ONBOARDING_FLOW_ACTIVE')).pipe(
          map(onboarding => {
            if (onboarding) {
              if (resp.status === CreditSetupStatus.VERIFICATION_FAILED) {
                this.creditSetupService.creditFailed.set(true);
                return this.router.createUrlTree(['onboarding']);
              }
            }

            if (resp.status === CreditSetupStatus.VERIFICATION_FAILED) {
              return this.router.createUrlTree(['credit-setup', 'credit-setup-error']);
            }
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            if ([CreditSetupStatus.VERIFIED, CreditSetupStatus.ENROLLED, CreditSetupStatus.FULFILLED].includes(resp.status)) {
              if (onboarding) {
                this.creditSetupService.creditSucceeded.set(true);
                return this.router.createUrlTree(['onboarding']);
              } else {
                return this.router.createUrlTree(['credit', 'dashboard']);
              }
            }

            if (resp.status === CreditSetupStatus.VERIFY_SMFA_TIMEOUT || resp.status === CreditSetupStatus.VERIFY_SMFA) {
              return this.router.createUrlTree(['credit-setup', 'verify', 'smfa']);
            }
            return true;
          })
        );
      })
    );

  }
}
